<div class="chart-js-responsive-container">
  <canvas
    baseChart
    [datasets]="chartData"
    [labels]="chartLabels"
    [options]="chartOptions"
    [legend]="chartLegend"
    [type]="chartType"
    (chartClick)="onChartClick($event)"
  ></canvas>
</div>
